import axios from "axios";

const api = axios.create({
  baseURL: "https://api-icash.herokuapp.com/",
});

export default api;
